import { render, staticRenderFns } from "./SynergismAntimatterDimensionRow.vue?vue&type=template&id=3019072b&scoped=true&"
import script from "./SynergismAntimatterDimensionRow.vue?vue&type=script&lang=js&"
export * from "./SynergismAntimatterDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./SynergismAntimatterDimensionRow.vue?vue&type=style&index=0&id=3019072b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019072b",
  null
  
)

export default component.exports